import React from 'react'
import Text from '../../Text'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'
import LaunchIcon from '../../icons/LaunchIcon'

function LegalDocumentsLinks({ title, links, textColor = { value: PALETTE.gray80 }, backgroundColor = { value: PALETTE.gray10 }, linkBackgroundColor = { value: PALETTE.white } }) {
  console.log(links)
  return (
    <div className={styles.wrapper} style={{ color: textColor.value, backgroundColor: backgroundColor.value }}>
      <div className={styles.titleWrapper}>
        <Text type="h1">{title}</Text>
      </div>
      <div className={styles.linksWrapper}>
        {
          links.map(l =>
            <a className={styles.linkWrapper} style={{ backgroundColor: linkBackgroundColor.value }} href={l.route.slug.current} target="_blank" key={l._key} rel="noreferrer">
              <Text type="h5">{l.title}</Text>
              <LaunchIcon/>
            </a>
          )
        }
      </div>
    </div>
  )
}

export default LegalDocumentsLinks
